
import Tooltip from '@mui/material/Tooltip';

export function OverflowTooltip({ children, customTooltip }: any) {

	return (
		<Tooltip
			title={customTooltip || children}
			followCursor={true}
			// onMouseEnter={handleShouldShow}
			// onMouseLeave={hideTooltip}
			// disableHoverListener={!isOverflowed}
			arrow
		>
			<span
			// ref={textElementRef}
			>
				{children}
			</span>
		</Tooltip>
	);
}
